export enum SettingsChannelProactiveMessageDataEventObjectsEnum {
  CREATE_NEW_PROACTIVE_MESSAGE = 'create_new_proactive_message',
  CREATE_PROACTIVE_MESSAGE = 'create_proactive_message',
  EDIT_PROACTIVE_MESSAGE = 'edit_proactive_message',
  LIST_PROACTIVE_MESSAGES = 'list_proactive_messages',
  DELETE_PROACTIVE_MESSAGE = 'delete_proactive_message',
}
